import { render, staticRenderFns } from "./NonConformanceNotification.vue?vue&type=template&id=79a898d8&"
import script from "./NonConformanceNotification.vue?vue&type=script&lang=js&"
export * from "./NonConformanceNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports